import {ClientConfiguration} from '@karma.run/editor'

export default {
  plugins: []
} as ClientConfiguration